import script from "./BasicAttribute.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicAttribute.vue?vue&type=script&setup=true&lang=js"

import "./BasicAttribute.vue?vue&type=style&index=0&id=41636504&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41636504"]])

export default __exports__